module.exports = __webpack_public_path__ + "static/32-line-gazelle-e4b9a794e11b0f6995e5ca2af69be217.png";